<template>
  <a-select
    :value="value"
    :disabled="disabled"
    @update:value="handleUpdate"
  >
    <a-select-option :value="BotActions.AddMessage">Agregar un nuevo mensaje</a-select-option>
    <!-- <a-select-option :value="BotActions.AddMessage">Agregar capturar variable</a-select-option> -->
    <a-select-option :value="BotActions.ContinueToOptions">
      Continuar con opciones múltipless
    </a-select-option>
    <a-select-option
      v-if="channelHasNodeType(channelType, NodeType.Buttons)"
      :value="BotActions.ContinueToButtons"
    >
      Continuar con botones
    </a-select-option>
    <a-select-option
      v-if="channelHasNodeType(channelType, NodeType.Card)"
      :value="BotActions.ContinueToCard"
    >
      Continuar con tarjetas
    </a-select-option>
    <a-select-option
      v-if="channelHasNodeType(channelType, NodeType.List)"
      :value="BotActions.ContinueToList"
    >
      Continuar con lista
    </a-select-option>
    <a-select-option :value="BotActions.TransferToQueue" v-if="!isConnectorString">
      Transferir a cola
    </a-select-option>
    <a-select-option :value="BotActions.BackToPreviousMenu" v-if="!isConnectorString">
      Volver a un nodo anterior
    </a-select-option>
    <a-select-option :value="BotActions.FinishChatbot" v-if="!isConnectorString">
      Finalizar chatbot</a-select-option>
    <a-select-option :value="BotActions.BackToPreviousMenu" v-if="!isConnectorString">
      Regresar a un nodo</a-select-option>
    <a-select-option
      v-if="ChannelsIvrConnector.includes(channelType) && nodeType == NodeType.Message && !isConnectorString"
      :value="BotActions.ContinueConnectorApi"
    >
      Consulta API
    </a-select-option>
  </a-select>
</template>

<script setup lang="ts">
import { BotActions, ChannelsIvrConnector, NodeType } from "@/app/chatbots/utils/enums";
import { channelHasNodeType } from "@/app/chatbots/utils/helpers";

defineProps<{
  value: number;
  disabled: boolean;
  channelType: number;
  nodeType: number;
  isConnectorString: boolean;
}>();

const emit = defineEmits<{
  "update:value": [value: number];
  change: [value: number];
}>();

const handleUpdate = (newValue: number) => {
  emit("update:value", newValue);
  emit("change", newValue);
};
</script>

<style scoped lang="sass"></style>
